<template>
  <div v-if="showWarning" class="type-xs-medium desk:type-sm-medium">
    <div
      v-if="canBuyMoreAmount === 0 && cartQty > 0"
      :class="['inline-flex relative p-12 pr-20 items-center gap-6 bg-warningLight', { 'mt-4': !noTopMargin, 'whitespace-nowrap': noWrap }]"
    >
      <div
        class="w-16 h-16 rounded-1 rotate-45 bg-warningLight absolute -top-4"
        :style="arrowStyle"
      />
      <img
        src="/icons/info.svg"
        class="w-16 h-16"
        alt="info"
      >
      {{ $t('stock.maxInCart') }}
    </div>
    <div
      v-else-if="currentQty >= canBuyMoreAmount && canBuyMoreAmount > 0"
      :class="['inline-flex relative p-12 pr-20 items-center gap-6 bg-warningLight', { 'mt-4': !noTopMargin, 'whitespace-nowrap': noWrap }]"
    >
      <div
        class="w-16 h-16 rounded-1 rotate-45 bg-warningLight absolute -top-4"
        :style="arrowStyle"
      />
      <img
        src="/icons/info.svg"
        class="w-16 h-16"
        alt="info"
      >
      {{ $t('stock.maxCanAdd', { num: canBuyMoreAmount }) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductVariantModel } from '#models/productVariant';
import { useGlobalContentStore } from '~/store/globalContent';
import { useUserStore } from '~/store/user';

const globalContent = useGlobalContentStore();
const userStore = useUserStore();

const props = defineProps<{
  activeVariant: ProductVariantModel,
  canBuyMoreAmount: number,
  currentQty: number,
  cartQty: number,
  arrowOffset?: number,
  arrowLeftOffset?: number,
  noTopMargin?: boolean,
  noWrap?: boolean,
}>();

const showWarning = computed(() =>
  userStore.isLoggedIn &&
  !globalContent.getAllowBackorders &&
  !props.activeVariant.isOnDemandProduct
);

const arrowStyle = computed(() => {
  if (props.arrowLeftOffset !== undefined) return { left: `${props.arrowLeftOffset - 8}px` };
  if (props.arrowOffset !== undefined) return { right: `${props.arrowOffset - 8}px` };
  return { left: '48px' };
});
</script>
